export default __webpack_public_path__ + "static/media/model.626bc09d.png";